import React from 'react';

interface PerformanceHeaderProps {
  isGenerating: boolean;
  lastGenerated: string | null;
  error: string | null;
  onGenerateAnalysis: (forceRegenerate: boolean) => void;
  formatDate: (dateString: string) => string;
}

const PerformanceHeader: React.FC<PerformanceHeaderProps> = ({ 
  isGenerating, 
  lastGenerated, 
  error, 
  onGenerateAnalysis,
  formatDate
}) => {
  return (
    <div className="row mb-4">
      <div className="col-12">
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <h1 className="h2 mb-2">Performance Overview</h1>
            <p className="text-muted mb-0">
              Comprehensive analysis of your learning journey and progress
            </p>
          </div>
          <div>
            <button
              className="btn btn-primary"
              onClick={() => onGenerateAnalysis(false)}
              disabled={isGenerating}
            >
              {isGenerating ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Generating...
                </>
              ) : (
                'Generate Analysis'
              )}
            </button>
            {lastGenerated && (
              <button
                className="btn btn-outline-secondary ms-2"
                onClick={() => onGenerateAnalysis(true)}
                disabled={isGenerating}
                title="Force regenerate analysis"
              >
                🔄 Refresh
              </button>
            )}
          </div>
        </div>

        {lastGenerated && (
          <div className="alert alert-info mt-3">
            <i className="fas fa-info-circle me-2"></i>
            Last analysis generated on {formatDate(lastGenerated)}
          </div>
        )}

        {error && (
          <div className="alert alert-danger mt-3">
            <i className="fas fa-exclamation-triangle me-2"></i>
            {error}
          </div>
        )}
      </div>
    </div>
  );
};

export default PerformanceHeader;